<ng-template #tabHeader>
  <ng-content select=".tab-item"></ng-content>
</ng-template>
